import React from 'react'
import { CircularProgress } from '@material-ui/core'
import { Button, OtpInput } from 'src/components'
import { useStyles } from './styles'
import { useEmailConfirmation } from './hooks/useEmailConfirmation'

export const ConfirmEmailVerification: React.FC = () => {
  const style = useStyles()
  const { otp, codeSent, isLoading, emailRegistered, isSending, sendCode, resendCode, submitCode, skip } =
    useEmailConfirmation()

  return (
    <div className={style.confirmEmailContainer}>
      <div className={style.confirmEmailForm}>
        <div className={style.confirmEmailTitleWrapper}>
          <h1>CONGADO</h1>
        </div>

        <div className={style.confirmEmailInfoWrapper}>
          <h2>Confirmação de E-mail</h2>
          <p className={style.confirmEmailDescription}>
            Confirme seu e-mail para maior segurança da sua conta. Você pode pular esta etapa e confirmar depois.
          </p>
          {emailRegistered && (
            <p className={style.confirmEmailEmail}>
              {codeSent ? 'Código enviado para: ' : 'Enviaremos um código para: '}
              <strong>{emailRegistered}</strong>
            </p>
          )}
        </div>

        {!codeSent ? (
          <div style={{ width: '100%', maxWidth: 532 }}>
            <Button
              onClick={sendCode}
              className='confirm-email__button'
              disabled={isSending}
              style={{ width: '100%' }}
              isLoading={isLoading}
            >
              Enviar Código
            </Button>

            <button type='button' onClick={skip} disabled={isSending} className={style.confirmEmailSkipButton}>
              Pular por enquanto
            </button>
          </div>
        ) : (
          <form onSubmit={submitCode} style={{ width: '100%', maxWidth: 532 }}>
            <div className={style.confirmEmailCodeWrapper}>
              <label>Informe abaixo o código que você recebeu no seu e-mail:</label>
              <OtpInput
                code={otp.code}
                disabled={isLoading}
                onChange={otp.handleChange}
                onKeyDown={otp.handleKeyDown}
                onPaste={otp.handlePaste}
                setRef={otp.setRef}
              />
            </div>

            <div className={style.confirmEmailResend}>
              <button
                type='button'
                onClick={resendCode}
                disabled={isLoading}
                className={style.confirmEmailResendButton}
              >
                {isSending ? (
                  <>
                    <CircularProgress size={16} style={{ color: '#784A42', marginRight: 8 }} />
                    Enviando...
                  </>
                ) : (
                  'Enviar novo código'
                )}
              </button>
            </div>

            <div className={style.confirmEmailButtons}>
              <Button type='submit' className='confirm-email__button' disabled={isLoading} isLoading={isLoading}>
                Confirmar E-mail
              </Button>

              <button type='button' onClick={skip} disabled={isLoading} className={style.confirmEmailSkipButton}>
                Pular por enquanto
              </button>
            </div>
          </form>
        )}
      </div>

      <div className={style.confirmEmailImageSide}></div>
    </div>
  )
}
